/** Quando true, `/sala/` usa LiveKit em vez de Cloudflare RealtimeKit. */
export const USE_LIVEKIT = process.env.REACT_APP_USE_LIVEKIT === "true";

export type MeetingVideoEngine = "livekit" | "cloudflare";

export function shouldUseLiveKit(forceEngine?: MeetingVideoEngine): boolean {
  if (forceEngine === "livekit") {
    return true;
  }
  if (forceEngine === "cloudflare") {
    return false;
  }
  return USE_LIVEKIT;
}

export function getSessionMeetingCollection(
  forceEngine?: MeetingVideoEngine,
): "livekitMeetings" | "dyteMeetings" {
  return shouldUseLiveKit(forceEngine) ? "livekitMeetings" : "dyteMeetings";
}

/** Dono da sala pelo padrão `sala-{uid}` (mesma regra do backend). */
export function isRoomOwnerById(roomId: string, userId: string | null | undefined): boolean {
  if (!roomId || !userId) {
    return false;
  }
  return roomId === `sala-${userId}` || roomId.startsWith(`sala-${userId}-`);
}

export function expectedOwnerUidFromRoomId(roomId: string): string | null {
  if (!roomId.startsWith("sala-")) {
    return null;
  }
  const rest = roomId.slice("sala-".length);
  const dash = rest.indexOf("-");
  return dash === -1 ? rest : rest.slice(0, dash);
}
